import { Department } from './department';

export class SignedInUserContract {
    constructor(
        public id: number,
        public username: string,
        public firstName: string,
        public lastName: string,
        public email: string,
        public fullName: string,
        public active: boolean,
        public department: Department,
        public migrated: boolean,
        public demo: boolean,
        public password: string,
    ) {}
}

export class SignedInUser {
    constructor(
        public id: number,
        public username: string,
        public firstName: string,
        public lastName: string,
        public email: string,
        public fullName: string,
        public active: boolean,
        public department: Department,
    ) {
        if (!fullName) {
            if (this.firstName && this.lastName) {
                this.fullName =  this.firstName.trim() + ' ' + this.lastName.trim();
            } else if (this.firstName && !this.lastName) {
                this.fullName =  this.firstName.trim();
            } else if (!this.firstName && this.lastName) {
                this.fullName =  this.lastName.trim();
            } else {
                this.fullName = 'N/A';
            }
        }
    }
}
